import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import InvoicingEmailSetup from "./invoicingEmailSetup";

const InvoicingEmailSetupPage = () => {
  return (
    <NavHeightAdjust>
      <InvoicingEmailSetup />
    </NavHeightAdjust>
  );
};

export default InvoicingEmailSetupPage;
